export const GET_ACTION_HISTORY = 'GET_ACTION_HISTORY';
export const SET_ACTION_HISTORY = 'SET_ACTION_HISTORY';
export const GET_USERS = 'GET_USERS';
export const SET_USERS = 'SET_USERS';
